<template>
    <div class="button-psn">
        <button
            id="button-tpa-psn"
            class="button-third-party btn btn-block"
            :data-tpa-type="tpaType"
            @click="clickHandler"
        >
            <svgIcon icon-holder-class="icon-third-party" icon-id="icon-psn" />
            <svgIcon icon-holder-class="wordmark-third-party" icon-id="wordmark-psn" />
        </button>
    </div>
</template>

<script>
import svgIcon from '@arena/toolkit/src/components/common/icon-svg';

export default {
    name: 'ButtonPSN',
    components: {
        svgIcon,
    },
    props: {
        tpaType: {
            type: String,
            default: '',
        },
    },
    methods: {
        clickHandler() {
            const psnURL = new URL(this.$store.state.configurations.psnLoginUrl);

            dataLayer.push({
                event: 'Start Social Account Linking',
                actionAttempted: 'link social',
                actionResult: 'confirm',
                tpaType: 'PSN',
            });

            this.$store.commit('setTpaClicked', 'PSN');

            window.location.href = psnURL.href;
        },
    },
};
</script>

<style lang="less" scoped>
button {
    background-color: #154488;
    &:hover {
        background-color: #1952a0;
    }
    &:focus {
        background-color: #113670;
    }
}
.icon-third-party {
    width: 22px;
    height: 22px;
    display: inline-block;
    vertical-align: middle;
    position: absolute;
    left: 14px;
    top: 14px;
}
.wordmark-third-party {
    height: 15px;
    margin-top: 3px;
    display: inline-block;
}
.button-third-party {
    margin: 0 0 10px;
    padding: 14px;
    position: relative;
}
</style>
